'use client';
import { logger } from '@magicschool/logger';
import { toast } from '@magicschool/spellbook';
import { useEffect } from 'react';
import { clearPersistedToast, getPersistedToast } from '@/util/persistedToast';

export default function PersistedToastHandlerClient() {
  useEffect(() => {
    const persistedToast = getPersistedToast();

    if (persistedToast) {
      try {
        toast({ title: persistedToast.message, status: persistedToast.type });
      } catch (e) {
        logger.error('Failed to parse toast data:', e, persistedToast);
      } finally {
        clearPersistedToast();
      }
    }
  }, []);

  return null;
}
